var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3334 7.99935C15.3334 12.0494 12.0502 15.3327 8.00008 15.3327C3.94999 15.3327 0.666748 12.0494 0.666748 7.99935C0.666748 3.94926 3.94999 0.666016 8.00008 0.666016C12.0502 0.666016 15.3334 3.94926 15.3334 7.99935ZM10.4714 5.52827C10.7318 5.78862 10.7318 6.21073 10.4714 6.47108L8.94285 7.99968L10.4714 9.52827C10.7318 9.78862 10.7318 10.2107 10.4714 10.4711C10.2111 10.7314 9.78899 10.7314 9.52864 10.4711L8.00004 8.94248L6.47145 10.4711C6.2111 10.7314 5.78899 10.7314 5.52864 10.4711C5.26829 10.2107 5.26829 9.78862 5.52864 9.52827L7.05723 7.99968L5.52864 6.47108C5.26829 6.21073 5.26829 5.78862 5.52864 5.52827C5.78899 5.26792 6.2111 5.26792 6.47145 5.52827L8.00004 7.05687L9.52864 5.52827C9.78899 5.26792 10.2111 5.26792 10.4714 5.52827Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleSolid);
export default __webpack_public_path__ + "static/media/close-circle-solid.9d459c217a28d39d19652f11f4905ef0.svg";
export { ForwardRef as ReactComponent };